import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { bulkEditOverlaySelector } from 'selectors/new-booking-selectors';
import NewBookingDuck from 'ducks/new-booking-duck';
import { newBookingOverlayType } from 'constants/new-booking-constants';
import BulkServiceConfigurationPanel from './bulk-service-configuration-panel';
import BulkVehicleTypePanel from './bulk-vehicle-type-panel';
import BulkDeliveryGuaranteePanel from './bulk-delivery-guarantee-panel';
import BulkAddOnPanel from './bulk-addon-panel';
import BulkOfferListOverLay from './offer-list/bulk-offer-list-overlay';
import CommonOverlay from './common-overlay';

const BulkEditOverlay = ({ dispatch, bulkEditOverlay }) => {
  const { visible = false, deliveryIDs, overlayType } = bulkEditOverlay;

  const onClose = useCallback(
    () => {
      dispatch(NewBookingDuck.creators.closeBulkEditOverlay());
    },
    [overlayType],
  );

  const ContentComponent = useMemo(
    () => {
      switch (overlayType) {
        case newBookingOverlayType.serviceConfiguration:
          return BulkServiceConfigurationPanel;
        case newBookingOverlayType.vehicleType:
          return BulkVehicleTypePanel;
        case newBookingOverlayType.addOn:
          return BulkAddOnPanel;
        case newBookingOverlayType.deliveryGuarantee:
          return BulkDeliveryGuaranteePanel;
        case newBookingOverlayType.offerConfiguration:
          return BulkOfferListOverLay;
      }
      return null;
    },
    [overlayType],
  );

  if (!deliveryIDs || deliveryIDs.length <= 0) {
    return null;
  }

  return (
    <CommonOverlay
      overlayKey={`${overlayType}-${deliveryIDs.join('-')}`}
      visible={visible}
      onClose={onClose}
    >
      {ContentComponent && (
        <ContentComponent deliveryIDs={deliveryIDs} onClose={onClose} />
      )}
    </CommonOverlay>
  );
};

BulkEditOverlay.propTypes = {
  bulkEditOverlay: PropTypes.shape({
    deliveryIDs: PropTypes.arrayOf(PropTypes.string),
    overlayType: PropTypes.string,
    visible: PropTypes.bool,
  }),
  dispatch: PropTypes.func.isRequired,
};

BulkEditOverlay.defaultProps = {
  bulkEditOverlay: undefined,
};

export default connect(state => ({
  bulkEditOverlay: bulkEditOverlaySelector(state),
}))(BulkEditOverlay);
